import styled from "styled-components";
import { primaryColor, primaryColorHover, bodyColor } from "../../../config/constants";
import { relativeButtonIndex } from "../../../config/zIndex";

export const LoginContainer = styled.div`
  margin: 48px auto;
  width: 288px;
  height: 360px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  @media (max-width: 690px) {
    margin: 25px auto;
  }
`;
export const LogoMimsImg = styled.img`
  margin: 30px auto 0;
`;
export const LogoSeparator = styled.div`
  margin: 25px 0;
  width: 100%;
  height: 2px;
  background-color: ${bodyColor};
`;
export const Input = styled.input`
  margin-top: 5px;
  padding: ${({ padding }) => padding && padding};
  width: 100%;
  height: 30px;
  font-size: 14px;
  outline: none;
  border: none;
  border-radius: 5px;
  background-color: ${bodyColor};
`;
export const LoginForm = styled.div`
  margin: 0 auto;
  width: 70%;
  &:input:focus {
    outline: none;
  }
`;
export const PasswordContainer = styled.div`
  margin-top: 15px;
`;
export const RelativeContainer = styled.div`
  position: relative;
`;
export const RelativeButton = styled.button`
  width: 23px;
  height: 23px;
  position: absolute;
  top: 8px;
  right: 5px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: ${relativeButtonIndex};
`;
export const ButtonSubmit = styled.button`
  margin: 20px 0 10px;
  padding: 10px 20px;
  width: 90px;
  border: none;
  font-size: 14px;
  color: #fff;
  background-color: ${primaryColor};
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
